module.exports = __webpack_public_path__ + "media/images/lb/866-2120bee3c240400cee309162c606ef7a.svg";